<template>
    <v-container ref="pageActions" fluid tag="section">

        <material-card icon="mdi-clipboard-text" icon-small title="FAQ" color="accent" class="mb-16">
            <!--Фильтры-->
            <v-row class="mx-2 mb-2">
                <v-col cols="12" md="3">
                    <v-select return-object item-text="name" item-value="name" v-model="project" :items="projects"
                        label="Проект" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select return-object item-text="text" item-value="value" v-model="theme" :items="faqThemes"
                        label="Тема" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-select return-object item-text="text" item-value="value" v-model="actual" :items="actualItems"
                        label="Актуальний" clearable @change="setQueryParam()"></v-select>
                </v-col>
                <v-col cols="12" md="3">
                    <v-text-field v-model="search" append-icon="mdi-magnify" label="Пошук" single-line
                        hide-details></v-text-field>
                </v-col>
            </v-row>

            <!--Таблица-->
            <v-data-table :headers="headers" :items="items" class="elevation-1" :search="search"
                :footer-props="{ itemsPerPageOptions: [5, 10, 20, 50, 100, -1] }" :options="{ itemsPerPage }">
                <template v-slot:item.is_active="{ item }">
                    <v-icon v-if="item.is_active" color="green">mdi-check-circle</v-icon>
                    <v-icon v-else color="red">mdi-close-circle</v-icon>
                </template>
                <template v-slot:item.action="{ item }">
                    <v-btn icon :to="`/faq/${item.id}`">
                        <v-icon color="blue">mdi-pencil</v-icon>
                    </v-btn>
                    <v-btn icon @click="deleteFaq(item)">
                        <v-icon color="red">mdi-delete</v-icon>
                    </v-btn>
                </template>
                <template v-slot:item.categories="{ item }">
                    <div v-if="item.categories">
                        <ul v-html="item.categories">
                        </ul>
                    </div>
                </template>
            </v-data-table>
            <!--Диалоговое окно для удаления-->
            <DialogConfitmDelete ref="dialogConfirmDelete" />
            <Preloader v-if="isSending" />
        </material-card>

        <v-btn v-if="isManager || isAdmin" class="add-user__button" fab dark color="primary" to="/faq/add/">
            <v-icon dark>
                mdi-plus
            </v-icon>
        </v-btn>

    </v-container>
</template>

<script>
import { HTTP } from '@/http-common';
import { mapGetters, mapMutations, mapActions } from 'vuex'
import { IMAGE_BASE_URL } from '@/env.config';

export default {
    name: 'faqList',
    data() {
        return {
            // Текущий проект
            project: {},
            // Количество элементов на странице
            itemsPerPage: 50,
            // Количество страниц
            isSending: false,
            headers: [
                { text: 'ID', value: 'id' },
                { text: 'Проект', value: 'project_name' },
                { text: 'Тема', value: 'theme_name' },
                { text: 'Категорії', value: 'categories' },
                { text: 'Питання', value: 'question', },
                { text: 'Вкл.', value: 'is_active' },
                { text: 'Управління', value: 'action', sortable: false },
            ],
            faqThemes: [],
            theme: null,
            items: [],
            search: '',
            actualItems: [
                { value: 1, text: 'Так' },
                { value: 0, text: 'Ні' }
            ],
            actual: null,
            imageBaseUrl: `${IMAGE_BASE_URL}faq/`
        }
    },
    computed: {
        ...mapGetters(['isManager', 'isAdmin', 'projects']),
    },

    mounted() {
        this.init();
    },

    watch: {
        // '$route': {
        //     handler() {
        //         this.getActions();
        //     },
        //     deep: true,
        // }
    },

    methods: {
        ...mapMutations(['setSnackbar']),
        ...mapActions(['getProjects']),

        async init() {
            await this.getProjects();
            await this.getFaqList();
            await this.getFaqThemes();
        },
        async getFaqList() {
            this.isSending = true;
            try {
                let { data } = await HTTP.post('/get-faq-list', {
                    project_id: this.project.id,
                    theme: this.theme ? this.theme.value : null,
                    actual: this.actual !== null ? this.actual.value : null,
                });
                this.items = data.content;
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        setQueryParam() {
            this.getFaqList();
        },
        async deleteFaq(item) {
            let isConfirmDelete = await this.$refs.dialogConfirmDelete.callDialog();
            if (!isConfirmDelete) return;
            this.isSending = true;

            try {
                await HTTP.post('/delete-faq', { id: item.id });
                await this.getFaqList();
            } catch (e) {
                this.setSnackbar({ color: 'error', text: e.message || e });
            } finally {
                this.isSending = false;
            }
        },
        async getFaqThemes() {
            try {
                let { data } = await HTTP.post('/get-faq-themes-select-list', {});
                this.faqThemes = data.content;
            } catch (error) {
                console.warn(error);
            }
        },

    },
}

</script>

<style>
.add-user__button {
    position: fixed;
    bottom: 20px;
    right: 20px;
}
</style>
